document.addEventListener('DOMContentLoaded', function () {
  // Function to update cart count badge
  function updateCartIcon() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = cart.item_count;
        const cartCountBadge = document.getElementById('cart-count');
        
        if (cartCountBadge) {
          cartCountBadge.innerText = cartCount;
          cartCountBadge.style.display = cartCount > 0 ? 'inline-block' : 'none';
        }
      })
      .catch(error => console.error('Error updating cart icon:', error));
  }

  // Update cart icon on page load
  updateCartIcon();

  // Add to cart functionality with quantity
  const addToCartButton = document.getElementById('add-to-cart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function () {
      // Get the product ID and quantity
      const productId = document.querySelector('[name="id"]').value;
      const quantity = parseInt(document.getElementById('quantity').value, 10);

      // Ensure quantity is at least 1
      if (isNaN(quantity) || quantity < 1) {
        alert('Please enter a valid quantity');
        return;
      }

      const formData = {
        items: [{
          id: productId,
          quantity: quantity
        }]
      };

      // Send AJAX request to add item to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Could not add item to cart');
        }
      })
      .then(data => {
        updateCartIcon(); // Update cart icon after adding to cart
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  }
});








// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

var formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



// ---------------------------------------------------------------------------
// Lazy Loading Sections
// ---------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function() {
  // Get current page URL
  const currentUrl = window.location.pathname;
  
  // List of pages where we don't want the lazy loading
  const excludedPages = [
    '/pages/services',
  ];

  // Only proceed if current page is not in excluded pages
  if (!excludedPages.includes(currentUrl)) {
    const sections = document.querySelectorAll('section');

    const observerOptions = {
      threshold: 0.01 // When 10% of the section is in view
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
          observer.unobserve(entry.target); // Unobserve once it has appeared
        }
      });
    }, observerOptions);

    sections.forEach(section => {
      observer.observe(section); // Observe each section
    });
  }
});